export const GET_MEMBER_REGISTER_ORIGIN = "GET_MEMBER_REGISTER_ORIGIN";
export const SHOW_MEMBER_REGISTER_ORIGIN_DETAILS = "SHOW_MEMBER_REGISTER_ORIGIN_DETAILS";